import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=fd155c32&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=fd155c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd155c32",
  null
  
)

export default component.exports